export const ModalAndTabsHeaderSize = 112;
export const GreyAreaHorizontalPadding = 30;
export const GreyAreaTopPadding = 30;
export const WhiteAreaHorizontalPadding = 30;
export const WhiteAreaTopPadding = 30;
